import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CollapsableIconCard } from 'modules/processes/components/CollpsableIconCard'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'

export const SocialSecurityUploadPreview = () => {
  const { previewValues } = usePreviewProvider()

  const uploadSocialSecurityCertificate = previewValues.requestId?.uploadSocialSecurityCertificate

  if (!uploadSocialSecurityCertificate) return null

  return (
    <Box paddingTop="s24" gap="s4" paddingBottom="s12">
      <Text.Normal weight="semibold" color="grey1000">
        {i18n.t(
          'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.title'
        )}
      </Text.Normal>
      <Box padding="s0" flexDirection="row">
        <Text.Normal>
          {i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.copy.first'
          )}
        </Text.Normal>

        <Box paddingLeft="s4">
          <Text.Normal weight="semibold">
            {i18n.t(
              'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.copy.second'
            )}
          </Text.Normal>
        </Box>
      </Box>
      <Box flexDirection="row" gap="s4">
        <Text.Normal>
          {i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.folder.first'
          )}
        </Text.Normal>
        <Text.Normal weight="semibold">
          {i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.folder.type'
          )}
        </Text.Normal>
        <Text.Normal>
          {i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.folder.where'
          )}
        </Text.Normal>
      </Box>
      <Box gap="s12" paddingTop="s8">
        <CollapsableIconCard
          title={i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.accreditation'
          )}
          cta={i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.social_security_certificate.cta'
          )}
          disabled
          leftIcon={{
            icon: 'edit-file-filled',
            color: 'purple1000',
            background: 'purple200',
          }}
        />
      </Box>
    </Box>
  )
}
